import TileV2 from './Tile.v2'

export default TileV2
// eslint-disable-next-line import/export
export * from './Tile.v2'
